import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3 grid pulse-email-body h-full" }
const _hoisted_2 = { class: "text-2xl font-semibold" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Attachments", -1)
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenderHtml = _resolveComponent("RenderHtml")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.subject), 1),
    _createVNode(_component_RenderHtml, { html: _ctx.body }, null, 8, ["html"]),
    _createElementVNode("div", null, [
      (_ctx.attachments.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-secondary",
              icon: ['fas', 'paperclip']
            }),
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (attachment) => {
              return (_openBlock(), _createElementBlock("a", {
                href: attachment.path,
                class: "d-block overflow-hidden p-2",
                key: attachment.id
              }, _toDisplayString(attachment.filename), 9, _hoisted_5))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}